'use client';

import React from 'react';
import { Box, MantineProvider } from '@mantine/core';
import SiteHeader from '@/components/SiteHeader';
import SiteFooter from '@/components/SiteFooter';
import HelpChangeSection from '@/components/HelpChangeSection';
import theme from '@/app/theme';

interface ClientPrivacyLayoutProps {
    children: React.ReactNode;
}

const ClientPrivacyLayout: React.FC<ClientPrivacyLayoutProps> = ({ children }) => {
    return (
        <MantineProvider theme={theme} defaultColorScheme="light" forceColorScheme="light">
            <Box>
                <SiteHeader />
                {children}
                <HelpChangeSection />
                <SiteFooter />
            </Box>
        </MantineProvider>
    );
};

export default ClientPrivacyLayout; 